import { render, staticRenderFns } from "./FormEditarAsignacionVehiculos.vue?vue&type=template&id=2c66ab1f&scoped=true&"
import script from "./FormEditarAsignacionVehiculos.vue?vue&type=script&lang=ts&"
export * from "./FormEditarAsignacionVehiculos.vue?vue&type=script&lang=ts&"
import style0 from "./FormEditarAsignacionVehiculos.vue?vue&type=style&index=0&id=2c66ab1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c66ab1f",
  null
  
)

export default component.exports